module.exports = __webpack_public_path__ + "static/media/give-guests-lots-2x.2fe3b348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/give-guests-lots-2x.png
// module id = 1216
// module chunks = 46